import { logger } from '@fiverr-private/obs';
import { statsFunctionWrapper } from '@fiverr-private/homepage_utils';
import { getBusinessPotential, BusinessPotential } from '@fiverr-private/business_entry_point';
import { SOURCE } from './constants';

const ALLOWED_POTENTIAL: BusinessPotential[] = ['high', 'medium'];

export const fetchBusinessPotential = async (businessUsersKimeraUrl: string): Promise<boolean> => {
    try {
        const fetcher = () =>
            getBusinessPotential({
                query: {},
                source: SOURCE,
                serviceBusinessUsersKimeraUrl: businessUsersKimeraUrl,
            });
        const {
            potential,
            realtimeRegistrationPotential,
            seller: isSeller,
        } = await statsFunctionWrapper(fetcher, 'jtbd.pro_migration.get_business_potential')();
        const hasPotential =
            ALLOWED_POTENTIAL.includes(potential) ||
            (!!realtimeRegistrationPotential && ALLOWED_POTENTIAL.includes(realtimeRegistrationPotential));

        return hasPotential && !isSeller;
    } catch (err) {
        logger.error(err as Error, {
            description: 'Failed to getBusinessPotential',
            source: 'ProMigrationCardImpl:checkPotential',
            team: 'dolphins',
        });

        return false;
    }
};
